<template>
  <div>
    <v-row style="background-color: #ccc">
      <v-col cols="3">
        <v-row justify="center"
          ><v-dialog v-model="dialog3" persistent max-width="85vw">
            <template v-slot:activator="{ on, attrs }">
              <img
                v-show="showArriveBtn && debugMode"
                :src="require('@/assets/arrive_btn.png')"
                alt=""
                class="left_btn mt-10"
                v-bind="attrs"
                v-on="on"
                @touchstart="
                  playBtnSe();
                  arrive();
                "
              />
              <img
                :src="require('@/assets/ride_btn.png')"
                alt=""
                class="left_btn mt-6"
                v-bind="attrs"
                v-on="on"
                @touchstart="
                  playBtnSe();
                  dialog3 = true;
                "
              />
            </template>
            <v-card>
              <v-card-title class="text-h5" style="font-weight: bold">
                乗車する人数を入力してください。
              </v-card-title>
              <v-card-text class="rideNumInput"
                ><v-btn-toggle class="mt-4" v-model="numToRide"
                  ><v-btn x-large>0<span class="nin">人</span></v-btn
                  ><v-btn x-large>1<span class="nin">人</span></v-btn
                  ><v-btn x-large>2<span class="nin">人</span></v-btn
                  ><v-btn x-large>3<span class="nin">人</span></v-btn
                  ><v-btn x-large>4<span class="nin">人</span></v-btn
                  ><v-btn x-large>5<span class="nin">人</span></v-btn
                  ><img
                    class="kurumaisu_icon"
                    :src="kurumaisu_icon"
                    alt=""
                    @touchstart="
                      playBtnSe();
                      selectKurumaisuIcon();
                    "
                  /><!--<v-btn x-large
                    >6<span class="nin">人</span></v-btn
                  >--></v-btn-toggle
                ></v-card-text
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <!--<v-btn x-large color="primary" @touchstart="callMobility"> 決定 </v-btn>-->
                <img
                  :src="require('@/assets/cancel2_btn.png')"
                  @touchstart="
                    playBtnSe();
                    dialog3 = false;
                    numToRide = 0;
                  "
                  alt=""
                  class="fix_btn mr-4"
                />
                <img
                  :src="require('@/assets/fix2_btn.png')"
                  @touchstart="
                    playBtnSe();
                    fixNumToRide();
                  "
                  alt=""
                  class="fix_btn"
                />
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialog5" persistent max-width="85vw">
            <v-card>
              <v-card-title class="text-h5" style="font-weight: bold">
                乗車する介護者の人数を入力してください。
              </v-card-title>
              <v-card-text class="rideNumInput"
                ><v-btn-toggle class="mt-4" v-model="numKaigo"
                  ><v-btn x-large>0<span class="nin">人</span></v-btn
                  ><v-btn x-large>1<span class="nin">人</span></v-btn
                  ><v-btn x-large
                    >2<span class="nin">人</span></v-btn
                  ></v-btn-toggle
                ></v-card-text
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <!--<v-btn x-large color="primary" @touchstart="callMobility"> 決定 </v-btn>-->
                <img
                  :src="require('@/assets/cancel2_btn.png')"
                  @touchstart="
                    playBtnSe();
                    dialog5 = false;
                    numToRide = 0;
                    numKaigo = 0;
                  "
                  alt=""
                  class="fix_btn mr-4"
                />
                <img
                  :src="require('@/assets/fix2_btn.png')"
                  @touchstart="
                    playBtnSe();
                    fixNumToRide2();
                  "
                  alt=""
                  class="fix_btn"
                />
              </v-card-actions>
            </v-card> </v-dialog
        ></v-row>
        <v-row justify="center"
          ><v-dialog v-model="dialog4" persistent max-width="85vw">
            <template v-slot:activator="{ on, attrs }">
              <img
                :src="require('@/assets/getoff_btn.png')"
                alt=""
                class="left_btn mt-6"
                v-bind="attrs"
                v-on="on"
                @touchstart="
                  playBtnSe();
                  dialog4 = true;
                "
              />
            </template>
            <v-card>
              <v-card-title class="text-h5" style="font-weight: bold">
                降車する人数を入力してください。
              </v-card-title>
              <v-card-text class="rideNumInput"
                ><v-btn-toggle class="mt-4" v-model="numToGetoff"
                  ><v-btn x-large>1<span class="nin">人</span></v-btn
                  ><v-btn x-large>2<span class="nin">人</span></v-btn
                  ><v-btn x-large>3<span class="nin">人</span></v-btn
                  ><v-btn x-large>4<span class="nin">人</span></v-btn
                  ><v-btn x-large>5<span class="nin">人</span></v-btn
                  ><!--<v-btn x-large
                    >6<span class="nin">人</span></v-btn
                  >--><img
                    class="kurumaisu_icon"
                    :src="kurumaisu_icon"
                    alt=""
                    v-show="kurumaisuRiding"
                    @touchstart="
                      playBtnSe();
                      selectKurumaisuIcon2();
                    " /></v-btn-toggle
              ></v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <!--<v-btn x-large color="primary" @touchstart="callMobility"> 決定 </v-btn>-->
                <img
                  :src="require('@/assets/cancel2_btn.png')"
                  @touchstart="
                    playBtnSe();
                    dialog4 = false;
                  "
                  alt=""
                  class="fix_btn mr-4"
                />
                <img
                  :src="require('@/assets/fix2_btn.png')"
                  @touchstart="
                    playBtnSe();
                    fixNumToGetoff();
                  "
                  alt=""
                  class="fix_btn"
                />
              </v-card-actions>
            </v-card> </v-dialog
          ><v-dialog v-model="dialog6" persistent max-width="85vw">
            <v-card>
              <v-card-title class="text-h5" style="font-weight: bold">
                降車する介護者の人数を入力してください。
              </v-card-title>
              <v-card-text class="rideNumInput"
                ><v-btn-toggle class="mt-4" v-model="numKaigo"
                  ><v-btn x-large>0<span class="nin">人</span></v-btn
                  ><v-btn x-large>1<span class="nin">人</span></v-btn
                  ><v-btn x-large
                    >2<span class="nin">人</span></v-btn
                  ></v-btn-toggle
                ></v-card-text
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <!--<v-btn x-large color="primary" @touchstart="callMobility"> 決定 </v-btn>-->
                <img
                  :src="require('@/assets/cancel2_btn.png')"
                  @touchstart="
                    playBtnSe();
                    dialog6 = false;
                    numKaigo = 0;
                  "
                  alt=""
                  class="fix_btn mr-4"
                />
                <img
                  :src="require('@/assets/fix2_btn.png')"
                  @touchstart="
                    playBtnSe();
                    fixNumToGetoff2();
                  "
                  alt=""
                  class="fix_btn"
                />
              </v-card-actions>
            </v-card> </v-dialog
        ></v-row>
        <v-row class="mt-6" justify="center" style="font-size: 20px">
          {{ passengers }}人乗車中</v-row
        >
        <v-row class="mt-6" justify="center"
          ><img
            :src="require('@/assets/break_start_btn.png')"
            alt=""
            class="left_btn mt-6"
            @touchstart="
              playBtnSe();
              inBreak = true;
            "
        /></v-row>
      </v-col>
      <v-col cols="9"><Map v-if="displayMap"></Map></v-col>
    </v-row>

    <!--<v-card>
      <v-card-text
        ><div class="driverCTR">
          {{ passengers }}人乗車中
          <v-btn class="ml-4" @touchstart="passengers -= 1">－</v-btn>
          <v-btn class="ml-4" @touchstart="passengers += 1">＋</v-btn>
        </div>
      </v-card-text>
      {{ busLatLng }}<br />
      errorMSG:{{ errorMSG }}<br />
      center:{{ center }}<br />
    </v-card>-->
    <v-dialog v-model="dialog" persistent max-width="400">
      <v-card>
        <v-card-title class="text-h5">
          {{ dialogTxt }}
        </v-card-title>
        <!--<v-card-text
          >Let Google help apps determine location. This means sending anonymous
          location data to Google, even when no apps are running.</v-card-text
        >-->
        <v-card-actions>
          <v-spacer></v-spacer>
          <!--<v-btn color="green darken-1" text @touchstart="requestNo">
            行かない
          </v-btn>-->
          <v-btn
            x-large
            color="primary"
            @touchstart="
              playBtnSe();
              requestOk();
            "
          >
            向かう
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog2" persistent max-width="600">
      <v-card>
        <v-card-title class="text-h5" style="font-weight: bold; padding: 25px">
          {{ dialog2Txt }}
        </v-card-title>
      </v-card> </v-dialog
    ><v-overlay :value="inBreak" style="z-index: 100"
      ><img
        :src="require('@/assets/break_end_btn.png')"
        alt=""
        style="width: 200px"
        @touchstart="
          playBtnSe();
          inBreak = false;
        "
    /></v-overlay>
  </div>
</template>

<script>
import store from "../store";
import Export from "../export";
import router from "../vue-router/index";
import Map from "./Map";
import { latLng, latLngBounds } from "leaflet";
export default {
  components: {
    Map,
  },
  async mounted() {
    if (this.driverMode == null) {
      clearInterval(this.getMobilityDataTimerId);
      router.push("/");
    }
    if (this.driverMode == true) {
      setInterval(this.putMobilityData, 3000);
      Export.setBreak(this.currentMobilityId, "false");
      var getMobilityData = await Export.getMobilityData();
      for (var i = 0; i < getMobilityData.data.length; i++) {
        if (getMobilityData.data[i].id == this.currentMobilityId) {
          this.capacity = getMobilityData.data[i].capacity;
        }
      }
      var txt =
        "Driver page started with mobility id " + this.currentMobilityId + ".";
      await Export.postMail(txt, store.state.mail);
    }
  },
  data() {
    return {
      displayMap: true,
      dialog: false,
      dialog2: false,
      dialog3: false,
      dialog4: false,
      dialog5: false,
      dialog6: false,
      dialogTxt: "",
      dialog2Txt: "",
      requestedData: [],
      numToRide: 0,
      numToGetoff: 0,
      numKaigo: 0,
      showArriveBtn: false,
      status: "standby",
      kurumaisu_icon: require("@/assets/kurumaisu_icon_off.png"),
      kurumaisuRiding: false,
      inBreak: false,
      capacity: 0,
      last_lat: null,
      last_lon: null,
      guide_call: new Audio(require("@/assets/guide_call.mp3")),
      btn_se: new Audio(require("@/assets/btn.mp3")),
      goingTo: null,
      debugMode: false,
    };
  },
  methods: {
    resetMap() {
      this.displayMap = false;
      this.$nextTick(() => {
        this.displayMap = true;
      });
    },
    async putMobilityData() {
      var recordId = this.getUniqueStr();
      var id = this.currentMobilityId;
      var lat = this.busLatLng[0];
      var lon = this.busLatLng[1];
      var heading = this.busHeading_1;
      var speed = this.busSpeed_1;
      var passengers = this.passengers;
      var timestamp = Date.now();
      var rotationAngle = this.busRotationAngle_1;
      var status = this.status;
      let formdata = new URLSearchParams();
      formdata.append("recordId", recordId);
      formdata.append("id", id);
      formdata.append("lat", lat);
      formdata.append("lon", lon);
      formdata.append("heading", heading);
      formdata.append("speed", speed);
      formdata.append("passengers", passengers);
      formdata.append("rotationAngle", rotationAngle);
      formdata.append("timestamp", timestamp);
      formdata.append("status", status);
      if (this.outOfService == false) {
        this.getRequestData();
        if (this.last_lat != null) {
          var d = this.getDistance(this.last_lat, this.last_lon, lat, lon);
        }
        if (this.last_lat == null || d > 0.015) {
          await Export.putMobilityData(formdata);
          //this.getRequestData();
          this.postMobilityOperationData(formdata, lat, lon, "");
          //到着ボタン押し忘れ対策として
          if (this.status == "going") {
            var distance = this.getDistance(
              this.goingTo.latlon_lat,
              this.goingTo.latlon_lon,
              lat,
              lon
            );
            if (distance < 0.03) {
              this.arrive();
            }
          }
        }
      }
    },
    async postMobilityOperationData(formdata, lat, lon, breakFalseOrTrue) {
      /*if (this.last_lat != null) {
        var d = this.getDistance(this.last_lat, this.last_lon, lat, lon);
      }
      if (this.last_lat == null || d > 0.015 || breakFalseOrTrue != "") {*/
      formdata.append("break", breakFalseOrTrue);
      await Export.postMobilityOperationData(formdata);
      this.last_lat = lat;
      this.last_lon = lon;
      //}
    },
    getDistance(lat1, lng1, lat2, lng2) {
      const R = Math.PI / 180;
      lat1 *= R;
      lng1 *= R;
      lat2 *= R;
      lng2 *= R;
      return (
        6371 *
        Math.acos(
          Math.cos(lat1) * Math.cos(lat2) * Math.cos(lng2 - lng1) +
            Math.sin(lat1) * Math.sin(lat2)
        )
      );
    },
    async getRequestData() {
      var timestamp = Date.now();
      var period = timestamp - 120000; //2分以内
      let formdata = new URLSearchParams();
      formdata.append("period", period);
      var getRequestData = await Export.getRequestData(formdata);
      if (getRequestData.data.length > 0) {
        this.requestedData =
          getRequestData.data[getRequestData.data.length - 1];
        if (this.requestedData.canceled == "true") {
          this.dialog = false;
          return;
        }
        if (this.dialog == false) {
          var goDialog = true;
          if (this.is_json(this.requestedData.accepted) == false) {
            goDialog = true;
          } else {
            var accepted = JSON.parse(this.requestedData.accepted);
            //自車が拒否した場合
            for (var i = 0; i < accepted.length; i++) {
              if (accepted[i].accepted == false) {
                if (accepted[i].mobilityId == this.currentMobilityId) {
                  goDialog = false;
                }
              }
            }
            //どの車かがOKした場合
            for (i = 0; i < accepted.length; i++) {
              if (accepted[i].accepted == true) {
                goDialog = false;
              }
            }
          }
          var timeout = this.callTimeout;
          var random = Math.random();
          var timeoutPlusRandom = timeout + random * 5000;
          /*if (this.inBreak == true) {
            setTimeout(() => {
              this.requestNo();
            }, timeoutPlusRandom);
          }*/
          if (
            goDialog == true &&
            this.status != "going" &&
            this.inBreak == false
          ) {
            //acceptedカラムがからのままなら
            this.dialogTxt =
              "【" +
              this.busStopIdToName(this.requestedData.busStopId) +
              "】より呼び出し、" +
              this.requestedData.numToRide +
              "人乗車希望";
            this.dialog = true;
            var id = this.requestedData.id;
            //var guide_call = new Audio(require("@/assets/guide_call.mp3"));
            setTimeout(() => {
              if (this.requestedData.id == id && this.dialog == true) {
                this.requestNo();
              }
            }, timeoutPlusRandom);
            this.guide_call.currentTime = 0;
            this.guide_call.play();
          }
        } else {
          //どの車かがOKした場合
          accepted = JSON.parse(this.requestedData.accepted || "null");
          if (accepted != null) {
            for (i = 0; i < accepted.length; i++) {
              if (accepted[i].accepted == true) {
                this.dialog = false;
              }
            }
          }
        }
      }
    },
    async requestNo() {
      //if (this.is_json(this.requestedData.accepted) == false) {
      var query = "?id=" + this.requestedData.id;
      var getRequestDataQuery = await Export.getRequestDataQuery(query);
      var requestedData = getRequestDataQuery.data[0];
      var accepted = [];
      if (requestedData.accepted != "") {
        accepted = JSON.parse(requestedData.accepted);
      }
      //var acceptedTimestamp = null;
      var data = {
        mobilityId: this.currentMobilityId,
        accepted: false,
      };
      accepted.push(data);
      var json = JSON.stringify(accepted);
      this.putRequestDataNo(this.requestedData.id, json);
      //}
      //リクエスト初期化
      this.requestedData = [];
      this.dialog = false;
    },
    requestOk() {
      if (this.is_json(this.requestedData.accepted) == false) {
        var accepted = [];
        var acceptedTimestamp = Date.now();
        var data = {
          mobilityId: this.currentMobilityId,
          accepted: true,
        };
        accepted.push(data);
        var json = JSON.stringify(accepted);
        this.putRequestData(this.requestedData.id, json, acceptedTimestamp);
      }
      this.dialog = false;
      this.dialog2Txt =
        "【" +
        this.busStopIdToName(this.requestedData.busStopId) +
        "】へ向かってください。";
      //到着ボタン表示
      this.showArriveBtn = true;
      //status変更
      this.status = "going";
      //goingTo設定
      var goingTo = null;
      for (var i = 0; i < this.busStopList.length; i++) {
        if (this.busStopList[i].id == this.requestedData.busStopId) {
          goingTo = this.busStopList[i];
        }
      }
      this.goingTo = goingTo;
      this.dialog2 = true;
      setTimeout(() => {
        this.dialog2 = false;
      }, 10000);
    },
    async putRequestData(id, json, acceptedTimestamp) {
      let formdata = new URLSearchParams();
      formdata.append("id", id);
      formdata.append("accepted", json);
      formdata.append("acceptedTimestamp", acceptedTimestamp);
      await Export.putRequestData(formdata);
    },
    async putRequestDataNo(id, json) {
      console.log("RN");
      let formdata = new URLSearchParams();
      formdata.append("id", id);
      formdata.append("accepted", json);
      await Export.putRequestDataNo(formdata);
    },
    is_json(data) {
      try {
        JSON.parse(data);
      } catch (error) {
        return false;
      }
      return true;
    },
    timestampToTime(timestamp) {
      var d = Date(timestamp);
      d = new Date(d);
      var year = d.getFullYear();
      var month = d.getMonth() + 1;
      var day = d.getDate();
      var hour = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
      var min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
      var sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
      return (
        year + "-" + month + "-" + day + " " + hour + ":" + min + ":" + sec
      );
    },
    busStopIdToName(id) {
      var name = "";
      for (var i = 0; i < this.busStopList.length; i++) {
        if (this.busStopList[i].id == id) {
          name = this.busStopList[i].name;
        }
      }
      return name;
    },
    fixNumToRide() {
      if (this.numToRide != null) {
        this.passengers += this.numToRide;
        if (this.passengers > this.capacity) {
          alert("定員をオーバーしますので乗車人数を修正します。");
          this.passengers = this.capacity;
        }
        this.postGettingOnAndOff(
          Date.now(),
          this.currentMobilityId,
          this.busLatLng[0],
          this.busLatLng[1],
          this.passengers - this.numToRide,
          this.passengers,
          this.numToRide,
          null,
          "false"
        );
        this.dialog3 = false;
        this.numToRide = 0;
      } else {
        this.dialog3 = false;
        this.dialog5 = true;
      }
    },
    //車椅子の場合
    fixNumToRide2() {
      this.passengers += this.numKaigo + 3;
      if (this.passengers > this.capacity) {
        alert("定員をオーバーしますので乗車人数を修正します。");
        this.passengers = this.capacity;
      }
      this.postGettingOnAndOff(
        Date.now(),
        this.currentMobilityId,
        this.busLatLng[0],
        this.busLatLng[1],
        this.passengers - (this.numKaigo + 3),
        this.passengers,
        this.numKaigo + 3,
        null,
        "true"
      );
      this.kurumaisuRiding = true;
      this.dialog5 = false;
      this.kurumaisu_icon = require("@/assets/kurumaisu_icon_off.png");
      this.numKaigo = 0;
    },
    fixNumToGetoff() {
      if (this.numToGetoff != null) {
        this.passengers -= this.numToGetoff + 1;
        if (this.passengers < 0) {
          alert("人数がマイナスになるので降車人数を修正します。");
          this.passengers = 0;
        }
        this.postGettingOnAndOff(
          Date.now(),
          this.currentMobilityId,
          this.busLatLng[0],
          this.busLatLng[1],
          this.passengers + (this.numToGetoff + 1),
          this.passengers,
          null,
          this.numToGetoff + 1,
          "false"
        );
        this.dialog4 = false;
        this.numToGetoff = 0;
      } else {
        this.dialog4 = false;
        this.dialog6 = true;
      }
    }, //車椅子の場合
    fixNumToGetoff2() {
      this.passengers -= this.numKaigo + 3;
      if (this.passengers < 0) {
        alert("人数がマイナスになるので降車人数を修正します。");
        this.passengers = 0;
      }
      this.postGettingOnAndOff(
        Date.now(),
        this.currentMobilityId,
        this.busLatLng[0],
        this.busLatLng[1],
        this.passengers + (this.numKaigo + 3),
        this.passengers,
        null,
        this.numKaigo + 3,
        "true"
      );
      this.kurumaisuRiding = true;
      this.dialog6 = false;
      this.kurumaisu_icon = require("@/assets/kurumaisu_icon_off.png");
      this.numKaigo = 0;
    },
    async postGettingOnAndOff(
      timestamp,
      mobilityId,
      lat,
      lon,
      passengerBefore,
      passengerAfter,
      getOnNum,
      getOffNum,
      wheelchair
    ) {
      let formdata = new URLSearchParams();
      formdata.append("timestamp", timestamp);
      formdata.append("mobilityId", mobilityId);
      formdata.append("lat", lat);
      formdata.append("lon", lon);
      formdata.append("passengerBefore", passengerBefore);
      formdata.append("passengerAfter", passengerAfter);
      formdata.append("getOnNum", getOnNum);
      formdata.append("getOffNum", getOffNum);
      formdata.append("wheelchair", wheelchair);
      await Export.postGettingOnAndOff(formdata);
    },
    async arrive() {
      //status変更
      this.status = "arrive";
      var arrivalTimestamp = Date.now();
      let formdata = new URLSearchParams();
      formdata.append("id", this.requestedData.id);
      formdata.append("arrival", "true");
      formdata.append("arrivalTimestamp", arrivalTimestamp);
      await Export.putRequestDataArrival(formdata);
      this.showArriveBtn = false;
      setTimeout(() => {
        this.status = "standby";
      }, 5000);
      //this.status = "standby";
    },
    selectKurumaisuIcon() {
      this.kurumaisu_icon = require("@/assets/kurumaisu_icon_on.png");
      this.numToRide = null;
    },
    selectKurumaisuIcon2() {
      this.kurumaisu_icon = require("@/assets/kurumaisu_icon_on.png");
      this.numToGetoff = null;
    },
    getUniqueStr(myStrong) {
      var strong = 1000;
      if (myStrong) strong = myStrong;
      return (
        new Date().getTime().toString(16) +
        Math.floor(strong * Math.random()).toString(16)
      );
    },
    playBtnSe() {
      this.btn_se.currentTime = 0;
      this.btn_se.play();
      this.btn_se = new Audio(require("@/assets/btn.mp3"));
    },
    restart() {
      location.reload();
    },
  },
  computed: {
    driverMode: {
      get() {
        return store.state.driverMode;
      },
      set(value) {
        store.state.driverMode = value;
      },
    },
    currentMobilityId: {
      get() {
        return store.state.currentMobilityId;
      },
      set(value) {
        store.state.currentMobilityId = value;
      },
    },
    center: {
      get() {
        var center = [store.state.center_lat, store.state.center_lon];
        return center;
      },
      set(value) {
        store.state.center_lat = value.lat;
        store.state.center_lon = value.lng;
      },
    },
    bounds() {
      var latLng = [];
      for (var i = 0; i < this.busStopList.length; i++) {
        latLng.push([
          Number(this.busStopList[i].latlon_lat),
          Number(this.busStopList[i].latlon_lon),
        ]);
      }
      var bounds = latLngBounds(latLng);
      return bounds;
    },
    busStopList: {
      get() {
        return store.state.busStopList;
      },
      set(value) {
        store.state.busStopList = value;
      },
    },
    busStop() {
      var busStop = [];
      for (var i = 0; i < this.busStopList.length; i++) {
        busStop.push({
          id: this.busStopList[i].id,
          name: this.busStopList[i].name,
          latlon: latLng(
            Number(this.busStopList[i].latlon_lat),
            Number(this.busStopList[i].latlon_lon)
          ),
          titles: this.busStopList[i].titles,
        });
      }
      return busStop;
    },
    busLatLng: {
      get() {
        var busLatLng = [
          store.state.busLatLng_lat_1,
          store.state.busLatLng_lon_1,
        ];
        return busLatLng;
      },
      set(value) {
        store.state.busLatLng = value;
      },
    },
    busHeading_1: {
      get() {
        return store.state.busHeading_1;
      },
      set(value) {
        store.state.busHeading_1 = value;
      },
    },
    busRotationAngle_1() {
      return this.busHeading_1 + 90;
    },
    busSpeed_1: {
      get() {
        return store.state.busSpeed_1;
      },
      set(value) {
        store.state.busSpeed_1 = value;
      },
    },
    passengers: {
      get() {
        return store.state.passengers;
      },
      set(value) {
        store.state.passengers = value;
      },
    },
    currentBusStopId: {
      get() {
        return store.state.currentBusStopId;
      },
      set(value) {
        store.state.currentBusStopId = value;
      },
    },
    currentBusStopName() {
      var name = "";
      for (var i = 0; i < this.busStop.length; i++) {
        if (this.busStop[i].id == this.currentBusStopId) {
          name = this.busStop[i].name;
        }
      }
      return name;
    },
    errorMSG: {
      get() {
        return store.state.errorMSG;
      },
      set(value) {
        store.state.errorMSG = this.errorMSG += value;
      },
    },
    mobilityData: {
      get() {
        return store.state.mobilityData;
      },
      set(value) {
        store.state.mobilityData = value;
      },
    },
    getMobilityDataTimerId: {
      get() {
        return store.state.getMobilityDataTimerId;
      },
      set(value) {
        store.state.getMobilityDataTimerId = value;
      },
    },
    businessHoursStart: {
      get() {
        return store.state.businessHoursStart;
      },
      set(value) {
        store.state.businessHoursStart = value;
      },
    },
    businessHoursEnd: {
      get() {
        return store.state.businessHoursEnd;
      },
      set(value) {
        store.state.businessHoursEnd = value;
      },
    },
    hour: {
      get() {
        return store.state.hour;
      },
      set(value) {
        store.state.hour = value;
      },
    },
    minute: {
      get() {
        return store.state.minute;
      },
      set(value) {
        store.state.minute = value;
      },
    },
    outOfService: {
      get() {
        return store.state.outOfService;
      },
      set(value) {
        store.state.outOfService = value;
      },
    },
    operationCommand: {
      get() {
        return store.state.operationCommand;
      },
      set(value) {
        store.state.operationCommand = value;
      },
    },
    callTimeout: {
      get() {
        return store.state.callTimeout;
      },
      set(value) {
        store.state.callTimeout = value;
      },
    },
  },
  watch: {
    numToRide() {
      if (this.numToRide != null) {
        this.kurumaisu_icon = require("@/assets/kurumaisu_icon_off.png");
      }
    },
    inBreak() {
      var recordId = this.getUniqueStr();
      var id = this.currentMobilityId;
      var lat = this.busLatLng[0];
      var lon = this.busLatLng[1];
      var heading = this.busHeading_1;
      var speed = this.busSpeed_1;
      var passengers = this.passengers;
      var timestamp = Date.now();
      var rotationAngle = this.busRotationAngle_1;
      var status = this.status;
      let formdata = new URLSearchParams();
      formdata.append("recordId", recordId);
      formdata.append("id", id);
      formdata.append("lat", lat);
      formdata.append("lon", lon);
      formdata.append("heading", heading);
      formdata.append("speed", speed);
      formdata.append("passengers", passengers);
      formdata.append("rotationAngle", rotationAngle);
      formdata.append("timestamp", timestamp);
      formdata.append("status", status);

      if (this.inBreak == true) {
        Export.setBreak(this.currentMobilityId, "true");
        this.postMobilityOperationData(formdata, lat, lon, "true");
      } else {
        Export.setBreak(this.currentMobilityId, "false");
        this.postMobilityOperationData(formdata, lat, lon, "false");
      }
    },
    operationCommand() {
      if (this.operationCommand.restart == "true") {
        var driverIds = JSON.parse(this.operationCommand.driverIds);
        if (driverIds.indexOf(String(this.currentMobilityId)) != -1) {
          this.restart();
        }
        if (this.currentMobilityId == null) {
          if (driverIds.indexOf("null") != -1) {
            this.restart();
          }
        }
      }
    },
  },
};
</script>
<style>
.wide-btn {
  font-size: 30px !important;
  font-weight: bold !important;
  margin: 10px 0;
}
.driverCTR {
  font-size: 30px !important;
  font-weight: bold !important;
}
.left_btn {
  width: 70%;
  height: auto;
  margin-left: 15px;
}
.kurumaisu_icon {
  height: 80px;
  width: auto;
  margin: 5px 0 0 5px;
}
.row {
  align-items: flex-start;
}
</style>
